import { Button, Checkbox, Popover, Select, Statistic } from 'antd'
import ColStat from '../../../../elements/ColStat'
import RowStat from '../../../../elements/RowStat'
import DateCell from '../../../../elements/Table/Cells/DateCell'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import CustomTable from '../../../../elements/Table/CustomTable'
import DateFilter, { dateFilterMethod } from '../../../../elements/Table/Filters/Date'
import SumFooter from '../../../../elements/Table/Footers/SumFooter'
import { get, isEmpty } from 'lodash'
import Authentication from '../../../../modules/Authentication'
import React, { Fragment, useEffect } from 'react'

import { withRouter } from 'react-router-dom'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import InfoText from '../../../../elements/InfoText'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import Status from '../../../../elements/Status'
import ViewDownload from '../../../../elements/ViewDownload'
import { numVal, sessionItemVal } from '../../../../modules/Utils'
import { streamUrl } from '../../../../variables/index'

const CheckboxTable = checkboxHOC(CustomTable)
const TransactionsUploadButton = withRouter(({ history }) => {
  return (
    <Button
      style={{ float: 'left', marginRight: 10 }}
      size={'small'}
      type={'dashed'}
      icon={'cloud-upload'}
      onClick={() => {
        history.push({
          pathname: '/finance/statements/upload',
        })
      }}>
      Upload Transactions File
    </Button>
  )
})

const auth = new Authentication()

function List(props) {
  const {
    fetching,
    fetch,
    selection,
    selectAll,
    list,
    company,
    onChangeCompany,
    onShow,
    onShowMap,
    toggleSelection,
    toggleAll,
    isSelected,
    tableRef,
    statement,
  } = props
  useEffect(() => {
    fetch()
  }, [])
  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }
  let columns = [
    {
      Header: 'ID',
      accessor: '_key',
      Cell: ({ original, value }) => {
        return (
          <Popover
            content={original.notes ? original.notes : <InfoText text={'No Notes'} />}
            placement="bottom"
            disabled={true}
            title="Notes">
            <a onClick={(e) => props.onEdit(e, original)}>{value}</a>
          </Popover>
        )
      },
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: DateCell,
      Filter: DateFilter,
      filterMethod: dateFilterMethod,
    },
    {
      Header: 'Type',
      accessor: 'type',
      Cell: ({ value }) => sessionItemVal('transactions_type_dropdown', value),
    },
    {
      Header: 'Currency',
      accessor: 'currency',
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      style: { textAlign: 'right' },
      sortMethod: (a, b) => (Number.parseFloat(a) < Number.parseFloat(b) ? 1 : -1),
      Cell: MoneyCell,
      filterMethod: (filter, row) => numVal(row, filter.id).toString().includes(filter.value),
      Footer: SumFooter,
    },
    {
      Header: 'Company',
      accessor: 'company.fn',
      hideable: true,
      hideDefault: true,
      width: 400,
    },
    {
      Header: 'Receipt type',
      accessor: 'receipt.type',
      hideable: true,
      hideDefault: true,
      width: 150,
    },
    {
      Header: 'Debit type',
      accessor: 'debit.type',
      hideable: true,
      hideDefault: true,
      width: 150,
    },
    {
      Header: 'Group Transaction',
      accessor: 'transactionType',
      hideable: true,
      hideDefault: true,
      width: 400,
    },
    {
      Header: 'Bank Account',
      accessor: 'bank.title',
      hideable: true,
      width: 250,
    },
    {
      Header: 'Transactions Ref',
      accessor: 'remittance.ref',
      hideable: true,
      hideDefault: true,
      width: 250,
    },
    {
      Header: 'Notes',
      accessor: 'notes',
      hideable: true,
      hideDefault: true,
      width: 250,
    },
    {
      Header: 'File',
      accessor: 'file',
      hideable: true,
      hideDefault: true,

      Cell: ({ value }) =>
        value && (
          <ViewDownload
            view={`${streamUrl}files/${value}?action=view&access_token=${auth.getAccessToken()}`}
            download={`${streamUrl}files/${value}?action=download&access_token=${auth.getAccessToken()}`}
          />
        ),
    },
    {
      Header: 'Allocated',
      accessor: 'allocated',
      hideable: true,
      hideDefault: true,

      Cell: ({ original, value }) => value && <Checkbox checked={value} />,
      filterMethod: (filter, row) => {
        if (filter.value === 'all') {
          return true
        }
        if (filter.value === true) {
          return row[filter.id] === true
        }
        return row[filter.id] !== true
      },
      Filter: ({ onChange, filter, ...rest }) => (
        <Select onChange={(value) => onChange(value)} style={{ width: '100%' }} value={filter ? filter.value : 'all'}>
          <Select.Option value="all">All</Select.Option>
          <Select.Option value={true}>Allocated</Select.Option>
          <Select.Option value={false}>Not Allocated</Select.Option>
        </Select>
      ),
    },
    {
      Header: 'Statement Code',
      accessor: 'statement.code',
      hideable: true,
      hideDefault: false,

      style: { textAlign: 'left' },
      Cell: ({ original, value }) => {
        return <a onClick={(e) => props.onShowStatement(original.statement)}>{value}</a>
      },
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ value }) => <Status value={value} />,
    },
  ]

  const placeholder = '_.__ '
  const debit = list.filter((l) => l.type === 'debit').reduce((acc, v) => v.amount + acc, 0) || placeholder
  const credit = list.filter((l) => l.type === 'credit').reduce((acc, v) => v.amount + acc, 0) || placeholder
  const diff = credit - debit || placeholder
  const currency = get(statement, 'currency')
  return (
    <Fragment>
      {!isEmpty(statement) && (
        <RowStat style={{ marginBottom: 40 }}>
          <ColStat span={8}>
            <Statistic title="Debit" value={debit} precision={2} suffix={currency} />
          </ColStat>
          <ColStat span={8}>
            <Statistic title="Credit" value={credit} precision={2} suffix={currency} />
          </ColStat>
          <ColStat span={8}>
            <Statistic title="Diff" value={diff} precision={2} suffix={currency} />
          </ColStat>
        </RowStat>
      )}

      <CheckboxTable
        {...checkboxProps}
        CreateButton={() => (
          <Button
            style={{ float: 'left', marginRight: 10 }}
            size={'small'}
            onClick={onShow}
            type={'primary'}
            icon={'plus'}>
            New{' '}
          </Button>
        )}
        ExtraButtons={() => (
          <Fragment>
            <TransactionsUploadButton />
            <Button
              style={{ float: 'left', marginRight: 10 }}
              size={'small'}
              onClick={onShowMap}
              disabled={selection.length === 0}
              type={'dashed'}
              icon={'plus'}>
              Map to Statement
            </Button>
          </Fragment>
        )}
        ExtraOptionsButtons={() => (
          <Fragment>
            <OrganisationsSelect
              onChange={onChangeCompany}
              value={company}
              placeholder={'Filter by a company'}
              size={'small'}
              style={{ width: '450px', paddingRight: 20, float: 'right' }}
            />
          </Fragment>
        )}
        withRef={tableRef}
        columns={columns.map((c) => ({
          style: { textAlign: 'center' },
          ...c,
        }))}
        data={list.filter((i) => i.transactionType !== 'Sub Transaction')}
        isFilterable={true}
        show={{ extraColumns: true }}
        loading={fetching}
        fetch={fetch}
        defaultPageSize={20}
      />
      <InfoText text={'Tip: Hold shift when sorting to multi-sort!'} />
    </Fragment>
  )
}

List.propTypes = {}
List.defaultProps = {
  fetching: false,
  fetch: () => console.error('Not Implemented'),
  list: [],
  selection: [],
}

export default List
